import { render } from "./ClientsTransactionPage.vue?vue&type=template&id=3d7e09e5&ts=true"
import script from "./ClientsTransactionPage.vue?vue&type=script&lang=ts"
export * from "./ClientsTransactionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__